import CalendarInfoStoreIndex from './schema/CalendarInfoStoreIndex';
import getCalendarItemNotificationManager from '../sse/store/store';
import reloadCalendarEventsAndNotify from './apis/reloadCalendarEventsAndNotify';
import TimeConstants from 'mini-datetime-utils/lib/dateValues/TimeConstants';
import { Calendar } from 'mini-event-to-calendar-association/lib/schema/Calendar';
import {
    clearReliableInterval,
    setReliableInterval,
} from 'mini-refresh-timers/lib/utils/reliableInterval';

export const LINKED_CALENDAR = 'LinkedCalendarEntry:#Exchange';

export default class CalendarFolderSubscriptionIndex implements CalendarInfoStoreIndex {
    private timersMap: Map<string, string>;

    constructor() {
        this.timersMap = new Map<string, string>();
    }

    onAddCalendarInfo(calendar: Calendar): void {
        const folderId = calendar.calculatedFolderId;
        if (calendar.type !== LINKED_CALENDAR) {
            getCalendarItemNotificationManager().subscribeNotifications(folderId);
        } else {
            this.timersMap.set(
                folderId,
                setReliableInterval(() => {
                    reloadCalendarEventsAndNotify(folderId);
                }, 5 * TimeConstants.MillisecondsIn1Min)
            );
        }
    }

    onDeleteCalendarInfo(calendar: Calendar): void {
        const folderId = calendar.calculatedFolderId;
        if (calendar.type !== LINKED_CALENDAR) {
            getCalendarItemNotificationManager().unsubscribeNotifications(folderId);
        } else if (this.timersMap.has(folderId)) {
            clearReliableInterval(this.timersMap.get(folderId));
            this.timersMap.delete(folderId);
        }
    }
}
